import { Field, FastField } from "formik";
import get from "lodash.get";
import React from "react";
import Checkbox from "../../../../../ui/widgets/checkbox";
import { FieldProps } from "formik/dist/Field";
import { CheckboxProps } from "../../../../../ui/widgets/checkbox/types.ts";

type CheckboxFieldProps = CheckboxProps & {
  name: string;
  forceReRender?: boolean;
  onChangeCallback?: (checked: boolean) => void;
};

type CheckboxWrapperProps = FieldProps & CheckboxFieldProps;

/**
 * Onboarding Checkbox Component - used in Formik-Fields.
 * @param field the formik fields
 * @param props the properties
 * @returns {*} a checkbox component
 * @constructor
 */
const CheckboxWrapper = ({
  field,
  ...props
}: CheckboxWrapperProps): React.JSX.Element => {
  const error = get(props, `form.errors.${field.name}`) as string;
  const touched = get(props, `form.touched.${field.name}`) as boolean;
  const { value, name } = field;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange({
      target: {
        value: e.target.checked,
        name: field.name,
      },
    });
    if (props.onChangeCallback) {
      props.onChangeCallback(e.target.checked);
    }
  };

  const onBlur = (event: React.FocusEvent<HTMLButtonElement>) => {
    field.onBlur({
      target: {
        // @ts-expect-error checked exists
        value: event.target.checked,
        name: field.name,
      },
    });
    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  return (
    <Checkbox
      {...props}
      id={name}
      checked={value}
      onChange={onChange}
      onBlur={onBlur}
      error={!!error && touched}
      errorText={error}
    />
  );
};

export default function CheckboxField(
  props: CheckboxFieldProps,
): React.JSX.Element {
  return props.forceReRender ? (
    <Field component={CheckboxWrapper} {...props} />
  ) : (
    <FastField component={CheckboxWrapper} {...props} />
  );
}
